import {locale} from './i18n.mjs';
let powerLocale, powerFormatter;
export function power(value) {
  const current=locale();
  if(current!==powerLocale){powerLocale=current;powerFormatter=new Intl.NumberFormat(current,{maximumFractionDigits:0});}
  return powerFormatter.format(value);
}
export function powerRange(min, max) {
  const a=power(min || max), b=power(max);
  return a===b ? b : `${a}–${b}`;
}

// Explicit current wins; only missing current uses the 50 kW fallback.
export function pointCurrent(current, kw) {
  const value = current?.toUpperCase();
  return value === 'AC' || value === 'DC' ? value : kw >= 50 ? 'DC' : kw > 0 ? 'AC' : null;
}
export const isDcPower = (current, kw) => pointCurrent(current, kw) === 'DC';
// Compare the whole-kW value shown to the user, including ties.
export const atDisplayedPeak = (kw, peak) => kw > 0 && Math.round(kw) >= Math.round(peak);
